import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './AddSkillModal.css';

const AddSkillModal = ({ isOpen, onClose, onAdd }) => {
  console.log('Modal render - isOpen:', isOpen);
  
  const [formData, setFormData] = useState({
    name: '',
    milestones: [{ title: '', completed: false }],
    resources: [{ title: '', url: '' }]
  });

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) {
      newErrors.name = 'Skill name is required';
    }
    if (!formData.milestones.some(m => m.title.trim())) {
      newErrors.milestones = 'At least one milestone is required';
    }
    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = validateForm();
    
    if (Object.keys(newErrors).length === 0) {
      const newSkill = {
        id: Date.now(),
        ...formData,
        milestones: formData.milestones
          .filter(m => m.title.trim())
          .map((m, index) => ({ ...m, id: index + 1 })),
        resources: formData.resources
          .filter(r => r.title.trim() && r.url.trim())
          .map((r, index) => ({ ...r, id: index + 1 }))
      };
      onAdd(newSkill);
      onClose();
    } else {
      setErrors(newErrors);
    }
  };

  const addMilestone = () => {
    setFormData(prev => ({
      ...prev,
      milestones: [...prev.milestones, { title: '', completed: false }]
    }));
  };

  const addResource = () => {
    setFormData(prev => ({
      ...prev,
      resources: [...prev.resources, { title: '', url: '' }]
    }));
  };

  const updateMilestone = (index, value) => {
    setFormData(prev => ({
      ...prev,
      milestones: prev.milestones.map((m, i) => 
        i === index ? { ...m, title: value } : m
      )
    }));
  };

  const updateResource = (index, field, value) => {
    setFormData(prev => ({
      ...prev,
      resources: prev.resources.map((r, i) => 
        i === index ? { ...r, [field]: value } : r
      )
    }));
  };

  const handleOverlayClick = (e) => {
    e.stopPropagation();
    onClose();
  };

  const handleContainerClick = (e) => {
    e.stopPropagation();
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <div className="modal-wrapper">
          <motion.div 
            className="modal-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={handleOverlayClick}
          />
          <motion.div 
            className="modal-container"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 50 }}
            onClick={handleContainerClick}
          >
            <div className="modal-header">
              <h2>Add New Skill</h2>
              <button 
                type="button"
                className="close-button" 
                onClick={onClose}
              >
                &times;
              </button>
            </div>

            <form onSubmit={handleSubmit} className="add-skill-form">
              <div className="form-group">
                <label htmlFor="skillName">Skill Name</label>
                <input
                  id="skillName"
                  type="text"
                  value={formData.name}
                  onChange={(e) => setFormData(prev => ({ ...prev, name: e.target.value }))}
                  placeholder="Enter skill name"
                  className={errors.name ? 'error' : ''}
                />
                {errors.name && <span className="error-message">{errors.name}</span>}
              </div>

              <div className="form-group">
                <label>Milestones</label>
                {formData.milestones.map((milestone, index) => (
                  <div key={index} className="milestone-input">
                    <input
                      type="text"
                      value={milestone.title}
                      onChange={(e) => updateMilestone(index, e.target.value)}
                      placeholder="Enter milestone"
                      className={errors.milestones ? 'error' : ''}
                    />
                  </div>
                ))}
                <button 
                  type="button" 
                  className="secondary-button"
                  onClick={addMilestone}
                >
                  + Add Milestone
                </button>
                {errors.milestones && <span className="error-message">{errors.milestones}</span>}
              </div>

              <div className="form-group">
                <label>Learning Resources</label>
                {formData.resources.map((resource, index) => (
                  <div key={index} className="resource-input">
                    <input
                      type="text"
                      value={resource.title}
                      onChange={(e) => updateResource(index, 'title', e.target.value)}
                      placeholder="Resource name"
                    />
                    <input
                      type="url"
                      value={resource.url}
                      onChange={(e) => updateResource(index, 'url', e.target.value)}
                      placeholder="Resource URL"
                    />
                  </div>
                ))}
                <button 
                  type="button" 
                  className="secondary-button"
                  onClick={addResource}
                >
                  + Add Resource
                </button>
              </div>

              <div className="modal-footer">
                <button type="button" className="secondary-button" onClick={onClose}>
                  Cancel
                </button>
                <button type="submit" className="primary-button">
                  Add Skill
                </button>
              </div>
            </form>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default AddSkillModal; 